import { render, staticRenderFns } from "./CourseRulePage.vue?vue&type=template&id=182973ba&scoped=true"
import script from "./CourseRulePage.vue?vue&type=script&lang=js"
export * from "./CourseRulePage.vue?vue&type=script&lang=js"
import style0 from "./CourseRulePage.vue?vue&type=style&index=0&id=182973ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182973ba",
  null
  
)

export default component.exports